import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, signal } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';

export interface EntityDetailData {
  id: string;
  name: string;
  entityCode?: string;
  totalEntities: number;
  totalResignedEntities: number;
  totalInvoices: number;
  totalShareClasses: number;
  totalBankAccounts: number;
  totalInvestments: number;
  totalAssets: number;
  totalLoans: number;
  totalDocuments: number;
}

@Component({
  selector: 'app-entity-detail-modal',
  templateUrl: './entity-detail-modal.component.html',
  styleUrls: ['./entity-detail-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AngularSvgIconModule]
})
export class EntityDetailModalComponent {
  @Input() isOpen: boolean = false;
  @Input() entityData: EntityDetailData | null = null;
  @Output() closeModal = new EventEmitter<void>();
  @Output() entityAction = new EventEmitter<{ action: string, entity: EntityDetailData }>();
  @Output() actionClicked = new EventEmitter<{ action: string, entity: EntityDetailData }>();

  readonly isModalExpanded = signal(false);
  isCollapsed: boolean = false;

  onClose(): void {
    this.closeModal.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  toggleModalSize(): void {
    this.isModalExpanded.update(v => !v);
  }
}
